
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.421 30.302c-.272 0-.51-.068-.75-.202l-7.67-4.953L8.33 30.1a1.41 1.41 0 01-1.534-.034 1.396 1.396 0 01-.512-1.448l2.42-8.425-7.228-6.028a1.347 1.347 0 01-.408-1.45c.17-.539.647-.876 1.193-.942l8.626-.609 3.887-8.39c.204-.471.682-.774 1.228-.774.545 0 1.022.303 1.227.775l3.887 8.39 8.625.606a1.342 1.342 0 011.193.942c.171.506 0 1.08-.409 1.45l-7.194 5.997 2.42 8.424a1.287 1.287 0 01-.51 1.448 1.393 1.393 0 01-.819.27z","fill-rule":"evenodd"}})])
          )
        }
      }
    